import { HttpRequest } from '@angular/common/http';
import { ApiEndpoints } from '@core/config/api-endpoints';

const WRITE_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

/**
 * ¿La petición puede mutar datos del tenant activo?
 * GraphQL: solo cuerpos con `mutation`. REST: métodos de escritura.
 */
export function isTenantWriteRequest(req: HttpRequest<unknown>): boolean {
  if (!WRITE_METHODS.has(req.method.toUpperCase())) {
    return false;
  }

  const url = req.url.toLowerCase();
  if (url.includes('/api/v1/auth/')) {
    return false;
  }

  if (url.includes(ApiEndpoints.graphql.toLowerCase())) {
    return isGraphqlMutationBody(req.body);
  }

  // REST de escritura bajo /api/
  return url.includes('/api/');
}

export function isGraphqlMutationBody(body: unknown): boolean {
  if (body == null) {
    return false;
  }
  let query: unknown;
  if (typeof body === 'string') {
    try {
      const parsed = JSON.parse(body) as { query?: unknown };
      query = parsed.query;
    } catch {
      return /\bmutation\b/i.test(body);
    }
  } else if (typeof body === 'object') {
    query = (body as { query?: unknown }).query;
  }
  return typeof query === 'string' && /\bmutation\b/i.test(query);
}
